export default {
    patentReview: {
        documentPane: {
            page: '第 {current} / {total} 页',
            previousPage: '上一页',
            nextPage: '下一页',
            'document': '待核稿文件',
            'readOnly': '只读',
            'localFile': '本地预览',
            'original': '原始文档',
            'text': '解析原文',
            'textHint': '解析原文用于核对和定位，不保留原文件版式。',
            'zoomIn': '放大',
            'zoomOut': '缩小',
            'loading': '正在加载文档…',
            'unsupported': '此格式暂不支持原版预览，可查看解析原文。Word 原版预览支持 DOCX。',
            'failed': '原文件加载失败，可重试或查看解析原文。',
            'noFile': '尚无可预览的原文件，可选择本地 Word / PDF，仅在浏览器中预览，不会上传或替换任务文件。',
            'retry': '重试',
            'unresolved': '暂时无法精确定位，请结合右侧问题与原文核对。',
            'missingInsertion': '缺失内容应补充在此处',
            'empty': '尚无解析内容',
        },
        results: {
            'results': '核稿结果',
            'sort': '结果排序',
            'importance': '按重要程度',
            'document': '按文章内顺序',
            'figureOrder': '按附图内顺序',
            'passed': '通过',
            'failed': '不通过',
            'manual': '需人工确认',
            'ignore': '忽略',
            'confirm': '确认',
            'ignored': '已忽略',
            'confirmed': '已确认',
            'summary': '核稿结果统计',
            'ruleName': '规则名',
            'unnamedRule': '未命名规则',
            'expand': '展开',
            'collapse': '收起',
            'status': '状态',
            'rule': '检查规则',
            'reason': '错误理由',
            'explanation': '结果说明',
            'suggestion': '修改建议',
            'location': '具体位置',
            'system': '系统规则',
            'custom': '自定义规则',
            'ruleUnavailable': '暂无规则原文',
            'locationUnavailable': '暂无可定位原文',
            'orderHint': '按已解析章节及原文位置排序；缺少位置的记录保留章节顺序。',
            'figureOrderHint': '按当前附图内的检查位置排序；缺少位置信息的记录保留检查顺序。',
        },
        figurePane: {
            workspace: '附图核对工作区', readOnly: '只读', recognizedCount: '已识别 {count} 个图幅',
            combinedReview: '附图核稿', abstractDrawing: '摘要附图',
            figure_overview: '逐图核稿', figure_completeness: '附图完整性', figure_compliance: '图面规范', figure_consistency: '图文一致性', abstract_drawing: '摘要附图',
            matrixTitle: '逐图核稿状态', drawing: '图幅', presenceCheck: '不缺失', visualCheck: '图内合规', claimsCheck: '权利要求一致性', specificationCheck: '说明书一致性',
            presenceShort: '存在', visualShort: '图内', claimsShort: '权要', specificationShort: '说明书',
            checkStatus_pass: '通过', checkStatus_fail: '不通过', checkStatus_manual: '需确认', checkStatus_pending: '待检测', numberNeedsConfirmation: '图号待确认',
            drawingNavigator: '附图导航', drawingTotal: '共 {count} 幅', collapseNavigator: '收起', expandNavigator: '展开', drawingRange: '第 {start}–{end} 幅',
            previousDrawing: '上一幅', nextDrawing: '下一幅', drawingPosition: '第 {current} / {total} 幅', drawingReviewTitle: '{drawing}核稿',
            missingFigure: '图幅缺失', missingFigureHint: '文字中提到了图{number}，但没有识别到对应图片。', abstractCandidates: '摘要附图候选',
            recognitionUnavailable: '尚无附图识别结果', recognitionUnavailableHint: '无法确认是否存在附图，也不会将本步骤判定为通过。',
            expectedFigures: '文字中预期的附图', actualFigures: '实际识别的附图', figureNo: '图{number}', unknownFigure: '未识别图号 · 第{number}幅',
            noFigureNumbers: '识别到了图片，但没有得到可核对的图号。', noFigures: '没有识别到附图', noFiguresHint: '请先确认申请是否应包含附图，并按需补齐文件。',
            notFound: '未找到', unknownCount: '另有 {count} 幅图片未识别出图号', inventoryBasis: '预期图幅依据', noDrawingsDescription: '未识别到附图说明，预期图幅可能不完整。',
            previewPending: '当前接口暂未提供单幅图片预览', noDescription: '暂无图面识别描述', referenceSigns: '已识别附图标记', noReferenceSigns: '未识别到附图标记',
            drawingsDescription: '附图说明', relatedFullText: '查看相关全文', noRelatedText: '暂无可用于核对的文字内容', abstractText: '摘要正文', noAbstract: '未识别到摘要正文',
            abstractCandidateHint: '当前版本展示候选图幅和摘要内容；摘要附图的明确选择仍以核稿结果为准。',
            confidence_high: '图号可信度高', confidence_medium: '图号由模型推断', confidence_low: '图号待确认',
            source_caption_regex: '来自原文图号', source_vision_match: '来自图文匹配', source_unknown: '图号来源未知',
        },
        workflow: {
            incompleteFileTitle: '文件内容不完整',
            skipMissingNotice: '接下来将跳过以下内容的检测：{sections}。如需完整核稿，请先补齐文件。',
            fileChecklist: '文件内容清单',
            notRecognized: '未识别到',
            missingSection: '未识别到{section}，后续将不检测{section}。',
            unconfirmedSection: '尚未确认是否识别到{section}，请核对原文并按需补齐。',
            supplementSection: '补齐文件：{section}',
            replaceSupplement: '更换文件',
            supplementPending: '待提交 · 文件仅暂存在当前页面，尚未加入本次核稿。',
            invalidSupplement: '请选择非空的 Word、PDF、TXT 或图片文件。',
            reviewCount: '{count} 条记录需复核',
            noConclusion: '暂无总体结论，请查看各部分结果。',
            claimsMaterial: '权利要求',
            specificationMaterial: '说明书',
            'detection': '文件解析',
            'claims': '权利要求核稿',
            'specification': '说明书核稿',
            'figures': '附图核稿',
            'report': '核稿结果',
            'title': '标题',
            'technical_field': '技术领域',
            'background': '背景',
            'summary': '发明内容',
            'detailed_description': '具体实施方式',
            'abstract': '摘要',
            'drawings': '附图',
            'drawings_description': '附图说明',
            'figure_overview': '逐图核稿',
            'figure_completeness': '附图完整性',
            'figure_compliance': '图面规范',
            'figure_consistency': '图文一致性',
            'abstract_drawing': '摘要附图',
            'unclassified': '跨部分／未归类',
            'all': '全部结果',
            'waiting': '等待结果',
            'partial': '部分结果可查看',
            'available': '结果可查看',
            'failed': '执行中断',
            'source': '原文与材料',
            'detected': '已识别',
            'unconfirmed': '待确认',
            'detecting': '识别中',
            'figureFound': '已识别 {count} 张附图，适用性待确认',
            'figureEmpty': '未识别到附图，是否需要补齐待确认',
            'figureUnknown': '尚无附图识别结果，不能判定不适用',
            'optional': '可选材料，不阻断申请核稿',
            'disclosure': '技术交底材料',
            'supplement': '补齐文件',
            'supplementHint': '当前任务暂不支持追加材料。请回到首页，重新上传完整材料并创建新任务。',
            'newTask': '返回首页重新上传',
            'close': '关闭',
            'reviewHint': '结果按文档部分整理。部分结果可查看时，后续检查仍可能补充问题。',
            'scopeHint': '未能确定所属部分的结果保留在下方，请一并复核。',
            'empty': '当前范围暂无检查记录，不代表已检查通过。',
            'noSource': '尚无可展示的原文，请查看文件检测结果。',
            'sourceWhole': '以下为完整说明书原文，具体子章节以问题定位为准。',
            'confirmDetection': '确认',
            'locate': '定位原文',
            'basis': '判断依据',
            'suggestion': '修改建议',
            'boundary': '适用边界',
            'notAssessed': '未完成判断',
            'pass': '通过',
            'issue': '需复核',
            'retry': '重新加载结果',
            'loadFailed': '结果加载失败，请重试。',
            'detectionHint': '检测各部分是否齐备、可解析；附图适用性与完整性也属于本环节。识别到内容不代表检查通过。',
            'pendingApplicability': '适用性待确认',
            'export': '导出报告',
            'reportPending': '报告尚未生成，可先查看已返回的各部分结果。',
        },
        entry: {
            materials: '核稿材料',
            applicationReview: '专利申请',
            description: '上传待核稿的申请文件，按需补充参考材料。',
            required: '必选',
            optional: '可选',
            choose: '选择文件',
            replace: '替换文件',
            remove: '移除 {name}',
            targetLabel: '申请文件',
            targetHint: '上传一份完整的专利申请稿，支持 Word、PDF，可拖入文件',
            supportingLabel: '其他技术材料',
            supportingHint: '上传多份用于核对技术一致性的文件，支持 Word、PDF、TXT、JPG、PNG',
            disclosureLabel: '技术交底材料',
            disclosureHint: '用于核对技术内容与申请稿的一致性 · Word / PDF / TXT',
            otherLabel: '其他材料',
            otherHint: '当前支持附图材料 · PDF / JPG / PNG',
            unsupportedFormat: '该材料不支持此文件格式，请按提示选择。',
            tooManyFiles: '申请文件与辅助材料合计最多 10 个文件。',
            oneTarget: '请提供一份完整申请文件。',
            fileCount: '已选 {count}/10 个文件',
            start: '开始核稿',
            submitting: '正在提交…',
            rules: '规则库',
            selectedLibraries: '{office} · {count} 个规则库',
            libraryHint: '由所选系统库确定受理局，可叠加同一受理局的自定义规则库。',
            taskCreated: '核稿任务已创建',
            ruleDialog: '选择规则库',
            ruleScopeHint: '选择一个系统库，可叠加同一受理局的自定义库。切换系统库会移除其他受理局的已选库。',
            selectionRequired: '请选择一个有效系统库；自定义库须与其受理局一致。',
            libraryLoadFailed: '规则库加载失败，请关闭后重试。',
        },
        list: {
            title: '核稿任务',
            empty: '暂无核稿任务',
            emptyHint: '上传专利初稿文件，即可开始形式核稿',
            rules: '条规则',
            tabTasks: '核稿任务列表',
            tabRules: '规则库',
        },
        status: {
            pending: '待处理',
            running: '执行中',
            completed: '已完成',
            failed: '失败',
        },
        steps: {
            '1_parsing': '解析文件',
            '2_extracting': '提取四要素',
            '3_figure_analysis': '附图分析',
            '4_formal_check': '形式审查',
            '5_finalizing': '最终报告',
        },
        stepStatus: {
            done: '已完成',
            running: '执行中',
            failed: '失败',
            pending: '等待中',
        },
        upload: {
            customRulesSection: {
                dialogTitle: '规则库',
                searchPlaceholder: '搜索规则库名称',
                customGroup: '自定义规则库',
                newGroup: '本次新上传',
                uploadButton: '上传规则',
                uploadFormats: '支持 .docx / .pdf / .pptx',
                confirm: '确认选择',
                confirmSelection: '确认',
                empty: '暂无规则库，点击"上传规则"添加',
                rulesEmpty: '该规则库未提取出规则',
                loadFailed: '加载规则库列表失败，请重试',
                uploadFailed: '上传规则文件失败，请重试',
                tableIndex: '序号',
                tableSection: '核稿部分',
                tableIssueDesc: '问题描述',
            },
            patentType: {
                label: '专利类型',
                invention: '发明',
                utility: '实用新型',
            },
            cancel: '取消',
        },
        detail: {
            backToList: '返回列表',
            taskHeader: {
                entry: '核稿审查',
                projectPackage: '专利审查项目包',
                unnamedTask: '未命名任务',
                progressTitle: '审查进度',
                autoRun: '自动运行',
                exportReport: '导出报告',
                exportNotReady: '核稿完成后可导出',
                finalizingCardSubtitle: '汇总结论',
                stepsExecutedCaption: '两项流程已执行',
                parsingCaption: '解析中',
                issueCountSuffix: '{count} 项问题',
            },
            materials: {
                mainFileTag: '专利申请文件',
                figureTag: '附图',
                disclosureTag: '交底书',
                attachmentTag: '附件',
            },
            parsing: {
                fileName: '文件名',
                fileNamePending: '正在识别主文件…',
                hint: '正在解析上传文件的文本内容…',
                inspectionSummary: '已定位 {located}/{total} 个内容部分',
                characterCount: '{count} 字',
                locate: '定位',
                missing: '未识别到内容',
                documentType: {
                    patent_application: '专利申请文件',
                    disclosure: '技术交底材料',
                    office_action: '审查意见通知书',
                    unknown: '文件类型待确认',
                },
            },
            extracting: {
                title: '发明名称',
                technical_field: '技术领域',
                background: '背景技术',
                summary: '发明内容',
                drawings_description: '附图说明',
                detailed_description: '具体实施方式',
                abstract: '摘要',
                claims: '权利要求书',
                specification: '说明书',
                figures: '附图',
                expand: '展开',
                collapse: '收起',
                empty: '暂无内容',
            },
            check: {
                pass: '通过',
                passCollapsed: '通过（{count} 条）',
                filterAll: '全部',
                filterInfo: '提示',
                filterWarning: '警告',
                filterError: '错误',
                filterCritical: '严重',
                location: '位置',
                suggestion: '修改建议',
                guidelineSource: '依据来源',
                empty: '暂无形式核稿问题',
                summaryPattern: '发现 {count} 处可定位的形式或企业规范问题',
                statTitle: '发现{count}处形式问题，其中，{officialCount}项违反官方规则，{customCount}项违反企业规则。',
                statFormalIssues: '形式问题',
                statOfficialViolations: '违反官方规则',
                statCustomViolations: '违反企业规则',
                summaryTitle: '形式检查·总结结论',
                summaryError: '{count}项错误',
                summaryWarning: '{count}项不符合规范',
                summaryRequireConfirm: '{count}项需人工确认',
                summaryStats: '共{total}条规则·{error}项·{warning}项·{requireConfirm}项·{pass}项已通过',
                systemRules: '系统规则',
                customRules: '企业规则',
                legendPass: '通过',
                legendFail: '不通过',
                legendPending: '需人工确认',
                summaryAllPassed: '全部通过',
                coverageTitle: '规则覆盖',
                coverageSource: '规则来源',
                coverageTotal: '规则数',
                coverageFail: '不通过',
                coverageVerify: '待确认',
                coveragePending: '待核查',
                coveragePassed: '通过',
            },
            table: {
                tabIssues: '问题定位表',
                tabCoverage: '检查覆盖',
                sourceOfficial: '官方规则',
                sourceCustom: '企业规则',
                sourceCustomEmpty: '暂无企业自定义规则命中数据',
                searchPlaceholder: '搜索权项、问题或法条',
                columnIndex: '#',
                columnLocation: '具体位置',
                columnIssue: '检查结果/问题',
                columnStatute: '适用法条/规则依据',
                columnSuggestion: '修改建议',
                columnEvidence: '证据',
                evidenceEmpty: '—',
                statusPending: '需修改',
                statusApplied: '已修改',
                statusIgnored: '已忽略',
                statusPass: '已通过',
                coverageColumnType: '规则类型',
                coverageColumnRule: '检查规则',
                coverageColumnContent: '规则内容',
                coverageColumnResult: '检查结果',
                coverageResultEmpty: '—',
                coverageResultFound: '发现问题',
                ruleTypeOfficial: '官方规则',
                ruleTypeCustom: '企业规则',
                itemUnit: '项',
                columnPatentSection: '专利章节',
                columnCheckRule: '检查规则',
                columnCheckResult: '检查结果',
                columnErrorReason: '错误理由',
                editButton: '编辑',
                adoptButton: '采纳改文',
                locateButton: '错误定位',
                locationModalTitle: '错误定位',
                locationModalContent: '定位信息：{location}',
                locationModalClose: '关闭',
                locationModalRuleLabel: '检查规则',
                locationModalLocationLabel: '位置',
                locationModalSuggestionLabel: '修改建议',
                locationModalBoundaryLabel: '适用边界',
                locationModalSourceTitle: '原稿内容',
                locationModalPositionUnresolved: '未能确定错误位置',
                statusRequireModify: '需修改',
                statusRequireConfirm: '需人工确认',
                statusPendingVerification: '待核查',
                multipleDescriptionsHint: '共 {count} 条错误理由，点击「错误定位」查看',
                multipleSuggestionsHint: '共 {count} 条修改建议，点击「错误定位」查看',
                locationModalMultipleLocations: '多条定位',
            },
            finalizing: {
                reportTitle: '专利核稿报告',
                reportSubtitle: '一种自适应多级阻尼缓冲器',
                conclusion: '总体结论',
                totalRules: '规则总数',
                passCount: '通过',
                warningCount: '警告',
                errorCount: '错误',
                criticalCount: '严重错误',
                conclusions: {
                    formal: '形式核稿结论',
                    art26_3: '第26条第3款结论',
                    art26_4: '第26条第4款结论',
                },
                riskMatrix: {
                    title: '实质核稿风险等级分布',
                    high: '高风险',
                    medium: '中风险',
                    low: '低风险',
                },
                conclusionValue: {
                    compliant: '符合',
                    risky: '基本符合但有风险',
                    non_compliant: '可能不符合',
                    insufficient: '材料不足无法完整判断',
                },
                dimensionConclusions: {
                    title: '检查维度结论',
                    unresolved: '未判定',
                },
                reportMeta: {
                    office: '受理局',
                    applicationType: '申请类型',
                    invention: '发明',
                    reportDate: '报告日期',
                    summaryTitle: '报告摘要',
                    summaryDefault: '优先修正明确的形式问题，并核实引用的可达性指向；保护范围与公开依据的需核实；拟增加的限定范围评估指向影响，完成修改与材料核实重新核稿。',
                    checkModule: '检查模块',
                    currentConclusion: '当前结论',
                    coverageScope: '覆盖范围',
                    formalCheck: '形式核稿',
                    substantiveCheck: '实质核稿',
                },
                formalCheckDetail: {
                    title: '形式问题明细',
                    ruleSource: '规则来源',
                    ruleCount: '规则数',
                    failed: '不通过',
                    needConfirm: '待确认',
                    passed: '通过',
                    pending: '待核查',
                    systemRules: '系统规则',
                    customRules: '自定义规则',
                    note1: '下表显示已有发现；其余规则保留待核查状态，待确认、待核查且不代表通过。',
                    note2: '原文需通过标注需要修改或标注"待做"不作编正修改处理。',
                    location: '原文与位置',
                    conclusion: '结论与风险',
                    suggestion: '修改建议与边界',
                },
            },
            featureMapping: {
                figuresNone: '本申请未包含附图',
                figuresFailed: '附图识别未完成，本次判断未结合附图内容',
                figureNoLabel: '图{no}',
                figureNoUnknown: '图号未标注',
                figureConfidenceMedium: '图号为推断结果',
                figureConfidenceLow: '图号无法确定',
                figureSignsLabel: '图面标引',
                figureNoSigns: '图面未见标引',
            },
            substantive: {
                filterHigh: '高风险',
                filterMedium: '中风险',
                filterLow: '低风险',
                filterAll: '全部',
                needsInventorConfirm: '需发明人确认',
                boundaryLabel: '适用边界',
                summaryPattern: '发现 {count} 处实质性问题，建议逐项核实',
                issuesLocations: '形式问题定位',
                title: '实质审查',
                checkResultTitle: '检查结果',
                issuesCount: '实质问题',
                highRiskCount: '高风险问题',
            },
            supplement: {
                title: '必要补充材料清单',
                columns: {
                    content: '需补充内容',
                    reason: '原因',
                    targetStatute: '用于解决的法条问题',
                    suggestedLocation: '建议补充位置',
                },
                empty: '暂无必要补充材料',
            },
            failed: {
                retryHint: '核稿任务执行失败，可返回列表重新上传文件',
            },
            reportLoadFailed: {
                message: '加载核稿报告失败，请重试',
                retry: '重新加载',
            },
            stepRunning: '该步骤正在执行，完成后可查看结果…',
            noStepSelected: '请选择一个步骤查看详情',
        },
        customRuleDocuments: {
            delete: '删除',
            edit: '编辑',
            deleteConfirm: '确认删除？',
            confirmYes: '确认',
            confirmNo: '取消',
            empty: '暂无规则文档',
            manageRulesLink: '管理规则',
            applicableScopeLabelText: '适用范围',
            sourceLabel: '规则来源',
            table: {
                name: '规则库名称',
                office: '地区',
                field: '技术领域',
                rulesCount: '规则数',
                updatedAt: '最近更新',
                actions: '操作',
                enabled: '启用',
            },
            rulesEmpty: '该文档未提取出规则',
            rulesLoadFailed: '加载规则明细失败，请重试',
            rulesCount: '{count} 条规则',
            status: {
                uploaded: '已上传',
                parsing: '解析中',
                parsed: '已解析',
                parse_failed: '解析失败',
            },
            upload: {
                title: '上传规则文档',
                addButton: '上传规则文档',
                fileTitle: '上传规则文档',
                fileHint: 'PDF、DOCX',
                chooseFile: '选择文件',
                removeFile: '移除',
                confirm: '开始上传',
                uploading: '正在上传…',
                nameLabel: '规则库名称',
                namePlaceholder: '不填则使用文件名',
                patentOfficeLabel: '地区',
                technicalFieldLabel: '技术领域',
            },
            technicalFieldOptions: {
                Common: '通用',
                Mechanical: '机械',
                Electrical: '电子',
                Chemical: '化学',
            },
            loadFailed: '加载规则文档失败，请重试',
            uploadFailed: '上传规则文档失败，请重试',
            updateFailed: '更新失败，请重试',
            deleteSuccess: '删除成功',
            deleteFailed: '删除失败，请重试',
            editDrawer: {
                title: '编辑规则库',
                save: '保存',
                saving: '保存中…',
                backToList: '返回列表',
            },
            detail: {
                loadFailed: '加载规则库失败，请重试',
            },
            import: '导入文件',
            importSuccess: '文件导入成功，正在解析规则…',
            importFailed: '文件导入失败，请重试',
            parseCompleted: '规则解析完成',
            parseTimeout: '规则解析中，请稍后手动刷新',
            parseFailed: '规则解析失败',
            parseError: '文件格式错误或不支持',
            selectedLabel: '已选 {count} 个规则库 · {rules} 条规则',
        },
        customRule: {
            addRule: '添加规则',
            addFromTemplate: '从模板添加',
            editRule: '编辑规则',
            editRuleDescription: '把检查条件写具体，让规则更容易被正确执行。',
            enabled: '启用',
            allRules: '全部规则',
            patentSection: '核稿部分',
            patentSectionPlaceholder: '请选择核稿部分',
            patentSectionTitle: '发明名称',
            patentSectionField: '技术领域',
            patentSectionBackground: '背景技术',
            patentSectionSummary: '发明内容',
            patentSectionClaims: '权利要求书',
            patentSectionSpecification: '说明书及附图',
            patentSectionImplementation: '具体实施方式',
            patentSectionAbstract: '摘要',
            patentSectionSpecificationOnly: '说明书',
            patentSectionFullText: '全文',
            problemDescription: '问题描述',
            problemDescriptionPlaceholder: '请输入问题描述',
            problemDescriptionTip: '写法建议：明确查对象 + 描述触发条件，避免只写"表述不规范"。',
            alertType: '提醒类型',
            severityInfo: '提示',
            severityWarning: '一般',
            severityError: '重点',
            problemDescriptionRequired: '问题描述不能为空',
            problemDescriptionMinLength: '问题描述至少需要 10 个字符',
            addRuleDialog: {
                title: '添加规则',
                subtitle: '从模板或已有文件中添加，现有规则会保留。',
                templateOption: '使用规则模板',
                templateOptionHint: '从常用核稿清单开始',
                importOption: '导入已有文件',
                importOptionHint: 'Word / Excel / PDF / PPT',
                chooseTemplate: '选择规则模板',
                chooseTemplateHint: '先选一套接近你的核稿标准的模板，下一步可以逐条修改。',
                templateCount: '{count} 个模板',
                ruleCount: '{count} 条规则',
                coveredSections: '包含检查项',
                importFileTitle: '上传规则文件',
                importFileHint: 'Word、Excel、PDF、PPT',
                chooseFile: '选择文件',
                removeFile: '移除',
                confirm: '保存',
                submitting: '正在加入…',
            },
        },
        customRuleLibraries: {
            custom: '自定义规则',
            title: '规则库',
            newLibrary: '+ 新增规则库',
            total: '共 {count} 个规则库',
            previous: '上一页',
            next: '下一页',
            selectPlaceholder: '请选择',
            clearFilters: '清除筛选',
            searchPlaceholder: '搜索规则库名称',
            gridView: '网格视图',
            listView: '列表视图',
            all: '全部',
            domains: {
                Common: '通用',
                Mechanical: '机械',
                Electrical: '电子',
                Chemical: '化学',
            },
            patentOffice: '受理局',
            system: '系统',
            systemLibraryName: '{office} 系统规则库',
            createDialogTitle: '新增规则库',
            ruleNameLabel: '规则库名称',
            ruleNamePlaceholder: '请输入规则库名称',
            domainLabel: '技术领域',
            create: '创建',
            createSuccess: '规则库已创建',
            createFailed: '创建失败，请重试',
            editDialogTitle: '编辑规则库',
            noRules: '暂无自定义规则库',
            noRulesDesc: '点击"新增规则库"创建你的第一个规则库',
        },
        catalog: {
            offices: {
                CNIPA: 'CNIPA',
                EPO: 'EPO',
                USPTO: 'USPTO',
                PCT: 'PCT',
            },
            enabled: '已启用',
            loading: '加载中...',
            error: '加载失败',
            retry: '重试',
            empty: '暂无数据',
            formalRules: '形式规则',
            substantiveDimensions: '实质维度',
            executeCheck: '执行检查',
            aiRewrite: 'AI 改写',
            more: '更多',
            reference: '参考',
            executionPass: '检查通过',
            executionTriggered: '命中问题',
            suggestionLabel: '建议',
            visionUnsupported: '该规则依赖附图分析结果，暂不支持单独执行',
            noDocumentSelected: '请先选择文档',
            executeCheckFailed: '执行检查失败，请重试',
            annotateToDocument: '标注到文档',
            annotated: '已标注',
            annotateSuccess: '批注已写入文档',
            annotateLocatingFailed: '未能定位到文档，请手动核实',
            annotateFailed: '写入批注失败，请重试',
            table: {
                ruleId: '规则编号',
                category: '类别',
                severity: '严重程度',
                keyPoint: '要点',
                patentSection: '专利条款',
                guidelineSource: '指南来源',
                dimensionId: '维度编号',
                statute: '法规',
                issueType: '问题类型',
            },
        },
        errors: {
            createTaskFailed: '创建核稿任务失败，请重试',
            loadTaskFailed: '加载任务状态失败，请重试',
            loadReportFailed: '加载核稿报告失败，请重试',
            loadTasksFailed: '加载任务列表失败，请重试',
            unsupportedOffice: '暂不支持该受理局',
            exportReportFailed: '导出核稿报告失败，请重试',
        },
    },
};
